import { css } from '@emotion/react'

export const FillerContent = css`
	display: block;
	content: '';
`
